// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"52352d07","100":"50f5774e","152":"61ccae6e","197":"1b0b977d","912":"2f0e22af"}[chunkId] + ".chunk.css";
};